import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'callCost',
    pure: false,
    standalone: false
})
export class CallCostPipe implements PipeTransform {
   transform(startDate: string, callRate: number, currentTime: Date): string {
      if (!startDate || !callRate || !currentTime) {
         return '';
      }
      const startDateObject = new Date(startDate);

      if (isNaN(startDateObject.getTime())) {
         return '';
      }

      const durationInMilliseconds = currentTime.getTime() - startDateObject.getTime();
      const durationInMinutes = durationInMilliseconds / (1000 * 60);
      const callCost = durationInMinutes * callRate;

      return `$${callCost.toFixed(2)}`;
   }
}
